import { render, staticRenderFns } from "./DisplayProductSlider.vue?vue&type=template&id=d0b842fa&name=display-product-slider&"
import script from "./DisplayProductSlider.vue?vue&type=script&lang=js&"
export * from "./DisplayProductSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports